import { gql } from '@apollo/client';

const PICK = 'races wins places roi';
const BUCKET = `key races favWins favPlaces tip { ${PICK} } consensus { ${PICK} } medianWinnerSp winnersShort winnersMid winnersLong`;

export const GET_RACE_INSIGHTS = gql`
  query GetRaceInsights($raceId: String!) {
    raceInsights(raceId: $raceId) {
      raceId
      trackCode
      trackName
      raceNumber
      distance
      fieldSize
      trackRaces
      byDistance { ${BUCKET} }
      byClass { ${BUCKET} }
      byRaceNumber { ${BUCKET} }
      byFieldSize { ${BUCKET} }
      barriers { barrier runners wins winIndex }
      settling { style winners winnerPct }
    }
  }
`;
